import SavvySpeak from "apps/savvyspeak/Dashboard";
import UserProfile from "components/profile/UserProfile";

export const de = {
    translation: {
        accounts: {
            label: "Account"
        },
        aitree: {
            launch: "Launch Chat",
            api: {
                title: "API Anbindungen"
            },
            dossier: {
                title: "Chat Parameter Konfiguration"
            },
            node: {
                displayTitle: "Anzeige",
                icon: "Symbol",
                label: "Name"
            }
        },
        analysis: {
            showSource: "Upload anzeigen",
            showAnalysis: "Analyse anzeigen",
            showMapping: "Mapping anzeigen",
            showImportData: "Importierte Daten anzeigen",
            refresh: "Daten updaten"
        },
        alert: {
            saved: "Gespeichert",
            update: "Aktualisiert",
            validated: "Validiert"
        },
        apis: {
            addApis: "API hinzufügen",
            name: "Name der API",
            noLinesAvailable: "Es sind keine APIs konfiguriert",
            label: {
                name: "Name der API",
                endpoint: "Endpunkt",
                description: "Beschreibung",
                method: "Methode",
                secret: "Geheimnis",
                last_run_at: "Zuletzt ausgeführt",
                title: "APIs",
                enabled: "Aktiv",
                interval: "Ausführungen alle ... Minuten"
            },
            title: "APIs",
            button: {
                addApi: "API hinzufügen",
                execute: "Ausführen"
            },
            options: {
                method: {
                    rest: "REST",
                    googleSheet: "Google Sheet"
                }
            }
        },
        address: {
            showMap: "Als Karte anzeigen",
            title: "Adressen", 
            add: "Adresse Hinzufügen",
            label: {
                name: "Bezeichnung",
                street: "Straße",
                city: "Stadt",
                state: "Bundesland",
                postal_code: "PLZ",
                country: "Land",
                address_type: "Typ",
                is_primary: "Primäre Addresse"
            }
        },
        assistant: {
            talk: "Vorlesen",
            stopTalking: "Stop Vorlesen",
            feedback: "Feedback geben",
            title: "Persönliche Assistentin",
            noAnswerNeeded: "Es ist keine Antwort nötig"
        },
        aicontrol: {
            header: {
                confirmAction: "Löschen bestätigen"
            },
            message: {
                delete: "Sind Sie sicher, dass sie dieses Element löschen möchten? Das kann nicht rückgängig gemacht werden."
            }
        },
        auth: {
            "username_password": "Benutzername und Passwort",
            "google_oauth": "Google OAuth",
            "microsoft_oauth": "Microsoft OAuth",
            "loginWithGoogle": "Mit Google anmelden",
            "loginWithMicrosoft": "Mit Microsoft anmelden"
        },  
        avatars: {
            emptyList: "Keine Avatare gefunden",
            emptyListTab: "Keine Avatare in \"{{tab}}\" gefunden",
            label: {
                name: "Name",
                title: "Titel",
                image_url: "Bild-URL",
                video_url: "Video-URL",
                description: "Beschreibung",
                is_deleted: "Gelöscht",
                is_enabled: "Aktiviert",
                created_at: "Erstellungsdatum"
            },
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen"
            },
            new: "Neuer Avatar",
            search: {
                button: "Avatar suchen",
                placeholder: "Suchen..."
            },
            tab: {
                all: "Alle Avatare",
                deleted: "Gelöschte Avatare"
            },
            table: {
                select: "Auswählen",
                name: "Name",
                title: "Titel",
                image_url: "Bild-URL",
                video_url: "Video-URL",
                description: "Beschreibung",
                delete: ""
            },
            upload: "Avatare hochladen"
        },        
        bank_accounts: {
            title: "Bankverbindungen",
            emptyList: "Keine Bankkonten gefunden",
            emptyListTab: "Keine Bankkonten in \"{{tab}}\" gefunden",
            label: {
                account_holder: "Kontoinhaber",
                iban: "IBAN",
                bic: "BIC",
                is_deleted: "Gelöscht",
                created_at: "Erstellungsdatum"
            },
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen"
            },
            new: "Neues Bankkonto",
            search: {
                button: "Bankkonto suchen",
                placeholder: "Suchen..."
            },
            tab: {
                all: "Alle Bankkonten",
                deleted: "Gelöschte Bankkonten"
            },
            table: {
                select: "Auswählen",
                account_holder: "Kontoinhaber",
                iban: "IBAN",
                bic: "BIC",
                delete: ""
            },
            upload: "Bankkonten hochladen"
        },        
        button: {
            add: {
                entry: "Neuen Eintrag hinzufügen",
                api: "API hinzufügen",
                avatar: "Berater hinzufügen",
                backgroundTask: "Automatisierung Hinzufügen",
                classification_entries: "Kategorie Hinzufügen",
                classification_groups: "Kategorisierung Hinzufügen",
                multimedia: "Multi Media Material hinzufügen",
                note: "Notiz hinzufügen",
                phrase: "Phrase hinzufügen",
                prompt: "Prompt hinzufügen",
                standardmessage: "Standard Nachricht Hinzufügen",
                tenantUser: "User Hinzufügen",
                todo: "Aufgabe hinzufügen",
                image: "Bild hinzufügen",
                dossierKey: "Eigenschaft hinzufügen",
                team_member: "Teammitglied hinzufügen",
                email: "Kanal hinzufügen"
            },
            openDetails: "Zur Detailansicht",
            enterFullscreen: "Vollbild",
            exitFullscreen: "Nebeneinander",
            run:{
                backgroundTask: "Automatisierungen starten"
            },
            calendar: "Kalender Ansicht",
            customer: {
                sync: "Kontakte aktualisieren"
            },
            delete: "Löschen",
            download: "Datei herunterladen",
            diagram: "Diagram Ansicht",
            done: "Fertig",
            edit: "Bearbeiten",
            email: {
                show: "Email anzeigen",
                sync: "Emails abrufen"
            },
            inspiration: "Inspirations Ansicht",
            kanban: "Kanban Ansicht",
            list: "Listenansicht",
            read: "Als gelesen markieren",
            refetch: "Nochmal versuchen",
            unread: "Als ungelesen markieren",
            update: "AI Update",
            undelete: "Wiederherstellen",
            upload: "Neue Medien hochladen",
            cancel: "Abbrechen",
            search: "Objekt Suchen"
        },
        categorySelector: {
            add: "{{key}} hinzufügen",
            placeholder: "Kategorien hinzufügen...",
            emptyResult: "Keine Kategorien gefunden",
            edit: "Kategorien bearbeiten"
        },
        chat: {
            input: {
                placeholder: "Lass uns Englisch üben"
            },
            menu: {
                switchToCurriculum: "Zur Lektion wechseln",
                switchToFreestyle: "Zur freien Unterhaltung wechseln",
                unmute: "Ton einschalten",
                mute: "Ton ausschalten",
                enableWriteChat: "Ich möchte schreiben",
                enableVoiceChat: "Ich möchte sprechen",
                translateToEnglish: "Übersetze dieses Wort oder diesen Ausdruck",
                suggest: "Gib mir ein Beispiel",
                correctImmediately: "Korrigiere mich sofort",
                correctAtTheEnd: "Korrigiere mich am Ende",
                showMistakeInChat: "Zeige Fehler im Chat",
                dontShowMistakeInChat: "Verstecke Fehler im Chat",
                pronounce: "Sprich dieses Wort oder diesen Ausdruck aus",
                repeat: "Wiederhole",
                correctBasic: "Wechsle in den einfachen Korrekturmodus",
                correctC2: "Wechsle in den fortgeschrittenen Korrekturmodus"
            },
            correction: {
                condensedErrors: "Gesamtnote, Grammatik- und Rechtschreibfehler"
            },
            error: {
                missingChatId: "Die Chat-ID ist ungültig"
            }
        },        
        chat_designs: {
            search: {
                placeholder: "Suche..."
            },
            emptyList: "Keine Chat-Designs gefunden",
            emptyListTab: "Keine Chat-Designs in \"{{tab}}\" gefunden",
            label: {
                name: "Name",
                description: "Beschreibung"
            },
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen",
            },
            new: "Neues Chat-Design anlegen",
            upload: "Chat-Designs hochladen",
            tab: {
                all: "Alle Chat-Designs",
                deleted: "Gelöscht"
            },
            title: "Chat-Designs",
            table: {
                select: "Auswählen",
                name: "Name",
                description: "Beschreibung",
                is_deleted: "Gelöscht",
                delete: ""
            }
        },        
        chats: {
            emptyList: "Keine Chats gefunden",
            emptyListTab: "Keine Chats in \"{{tab}}\" gefunden",
            media: {
                name: "Medienthema",
                description: "Beschreibung",
                type: "Medientyp",
                link: "Medienlink",
                calltoaction: "Handlungsaufforderung",
                thumbnailimage: "Vorschaubild",
                title: "Unterstützende Medien",
                add: "Medien hinzufügen",
                selectName: "Wählen Sie einen Mediennamen"
            },
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                avatar_type: "Stimme für alle {{selected}} ändern",
                conversation_starter: "Start für alle {{selected}} ändern",
                chat_design_id: "Design für alle {{selected}} ändern",
                delete: "Alle {{selected}} löschen",
            },
            options: {
                chatType: {
                    did: "D-ID Integration",
                    elevenlabs: "ElevenLabs Integration",
                    elevenlabsTest: "Teste ElevenLabs Integration",
                    browservoice: "Stimme des Web Browsers"
                },
                mediaType: {
                    image: "Bild",
                    deflect: "Ablenkung",
                    video: "Video"
                },
                paramType: {
                    contact: "Kontakt-Id",
                    knowledge: "Hintergrund-Wissens-Id",
                    product: "Produkt-Id",
                    order: "Order-Id",
                    custom: "Benutzerdefiniert"
                },
                paramSource: {
                    url: "URL",
                    chat: "Chat"
                },
                paramUsage: {
                    analysis: "Analyse",
                    chat: "Chat"
                },
                conversationStarter: {
                    customer: "Kunde",
                    chat: "Chat (statisch)",
                    agent: "Agent"
                } 
            },
            params: {
                addParam: "Parameter Hinzufügen",
                name: "Parameter-Name",
                description: "Beschreibung",
                type: "Parameter-Typ",
                default_value: "Default-Wert",
                source: "Quelle",
                usage: "Verwendung",
                selectName: "Wählen Sie einen Parameternamen"
            },
            search: {
                placeholder: "Suchen..."
            },
            settings: {
                name: "Chat-Name",
                description: "Beschreibung",
                conversation_headline: "Gesprächsüberschrift",
                conversation_starter: "Gesprächs-Eröffnung",
                conversation_subline: "Gesprächsunterzeile",
                conversation_opening_text: "Gesprächseröffnungstext",
                avatar_width: "Avatar-Breite",
                avatar_height: "Avatar-Höhe",
                avatar_type: "Avatar-Typ",
                voice_name: "Stimmenname",
                voice_software_key: "Sprachsoftware-Schlüssel",
                notes_activated: "Notizen aktiviert",
                picture: "Bild-Upload",
                video: "Video-Upload",
                title: "Chat-Einstellungen",
                addChat: "Chat hinzufügen",
                selectName: "Wählen Sie einen Chat-Namen"
            },
            tab: {
                all: "Alle Chats",
                recent: "Recent Chats",
                deleted: "Gelöschte Chats"
            },
            table: {
                select: "Auswählen",
                picture_upload_id: "Avatar",
                name: "Name",
                description: "Beschreibung",
                avatar_type: "Stimme",
                conversation_starter: "Start",
                chat_design_id: "Design",
                delete: ""
            },
        },
        chat_sessions: {
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen",
            },
            tab: {
                all: "Alle Chats",
                recent: "Aktuelle Chats",
                deleted: "Gelöschte Chats"
            },
            search: {
                placeholder: "Suche..."
            },
            label: "Chats",
            table: {
                select: "Auswählen",
                contact_id: "Kunde",
                lastchatactivity: "Letzte Aktivität",
                label: "Gesprächsphase",
                stagecompletion: "Phasen Fortschritt",
                leadscore: "Lead Score",
                evaluationtext: "KI Bewertung",
                delete: ""
            },
            emptyList: "Keine Gesprächsnotizen gefunden",
            emptyListTab: "Keine Gesprächsnotizen in \"{{tab}}\" gefunden",
            new: "Neue Gesprächsnotiz anlegen",
            upload: "Gesprächsnotizen hochladen"
        },
        classification: {
            label: {
                object_type: "Objekttyp",
                name: "Name",
                description: "Beschreibung",
                is_single_selection: "Einzelauswahl",
                is_primary_category: "Primärkategorie",
                is_pre_classify: "Vorabklassifizierung",
                text_analysis_length: "Textanalyse Länge",
                requires_response: "Erfordert Antwort",
                requires_analysis: "Erfordert Analyse",
                rule_type: "Art der Regel",
                rule_sql: "Code für die Regel (SQL)"
            }
        },
        companies: {
            label: {
                name: "Name",
                website: "Website",
                employees: "Mitarbeiter",
                industry: "Industrie", 
                annual_revenue: "Jahresumsatz"
            }
        },
        contact_relationships: {
            title: "Beziehung",
            emptyList: "Keine Kontaktbeziehungen gefunden",
            emptyListTab: "Keine Kontaktbeziehungen in \"{{tab}}\" gefunden",
            label: {
                type: "Beziehung",
                from_contact_id: "Von Kontakt",
                to_contact_id: "Zu Kontakt",
                is_deleted: "Gelöscht",
                created_at: "Erstellungsdatum"
            },
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen"
            },
            new: "Neue Kontaktbeziehung",
            options: {
                type: {
                    child: "Kind",
                    spouse: "Lebenspartner",
                    helper: "Helfer"
                }
            },
            search: {
                button: "Kontaktbeziehung suchen",
                placeholder: "Suchen..."
            },
            tab: {
                all: "Alle Kontaktbeziehungen",
                deleted: "Gelöschte Kontaktbeziehungen"
            },
            table: {
                select: "Auswählen",
                type: "Beziehungstyp",
                from_contact_id: "Von Kontakt",
                to_contact_id: "Zu Kontakt",
                delete: ""
            },
            types: {
                children: {
                    title: "Kinder",
                    new: "Kind Hinzufügen"
                },
                helpers: {
                    title: "Helfer/In",
                    new: "Helfer Hinzufügen"
                },
                spouses: {
                    title: "Lebenspartner/In",
                    new: "Lebenspartner Hinzufügen"
                },
            }, 
            upload: "Kontaktbeziehungen hochladen"
        },        
        contracts: {
            emptyList: "Keine Verträge gefunden",
            emptyListTab: "Keine Verträge in \"{{tab}}\" gefunden",
            new: "Neuer Vertrag",
            search: {
                button: "Vertrag suchen",
                placeholder: "Suchen..."
            },
            tab: {
                all: "Alle Verträge",
                deleted: "Gelöschte Vertrage"
            },
            label: {
                product_id: "Id",
                contact_id: "Kunde",
                name: "Name",
                notes: "Anmerkungen",
                type: "Typ",
                created_at: "Erstellungsdatum",
                start_date: "Startdatum",
                end_date: "Enddatum",
                status: "Status"
            },
            table: {
                product_id: "Id",
                contact_id: "Kunde",
                name: "Name",
                notes: "Anmerkungen",
                type: "Typ",
                start_date: "Startdatum",
                end_date: "Enddatum",
                status: "Status",
                delete: ""
            },
            upload: "Verträge hochladen"
        },
        coach: {
            title: "Vertriebs-coach",
            label: {
                OverallRating: "Gesamtbewertung",
                Summary: "Zusammenfassung",
                SuggestedImprovement: "Vorgeschlagene Verbesserung",
                Spelling: "Rechtschreibung",
                Precision: "Präzision",
                Professionalism: "Professionalität",
                Friendliness: "Freundlichkeit",
                Clarity: "Klarheit",
                Conciseness: "Prägnanz",
                Engagement: "Engagement",
                StructureFlow: "Struktur & Fluss",
                GrammarSyntax: "Grammatik & Syntax",
                ToneConsistency: "Ton-Konsistenz",
                Actionability: "Handlungsaufforderung",
                Relevance: "Relevanz",
                Personalization: "Personalisierung",
                BrandConsistency: "Markenkonsistenz",
                CTAIncluded: "CTA enthalten"
            },
            section: {
                details: "Detaillierte Analyse"
            },
            button: {
                proofRead: "Korrekturlesen",
                reformulate: "Korrektur einarbeiten"
            }
        },
        copy: {
            clipboard: "In Zwischenablage Kopieren",
            note: "Erstelle eine Notiz",
            text: "Soll ich den markierten text für dich notieren?",
            title: "Markierter eMail text",
            todo: "Erstelle eine Aufgabe"
        },
        customer: {
            analysis: "KI-Analyse",
            analytics: {
                title: "Kunden-Analyse"
            },
            fillAI: "Profil mit KI verfollständigen",
            logMeeting: "Meeting dokumentieren",
            addNote: "Notiz hinterlegen",
            addOrder: "Order erstellen",
            addSocialMediaAccount: "Social Media Account erstellen",
            addTodo: "Todo erstellen",
            details: "Details",
            filter: {
                owner: "Owner",
                verified: "Verifiziert",
                type: "Typ",
                referrer: "Referrer"
            },
            label: {
                firstname: "Vorname",
                additionalFirstNames: "Mittel-Namen",
                lastname: "Nachname",
                birthday: "Geburtsdatum",
                companyName: "Firmenname",
                email: "Email Adresse",
                phone: "Primäre Telefonnummer",
                title: "Titel",
                type: "Kontakt-Typ",
                satisfaction: "Zufriedenheit",
                upsellPotential: "Upsell Potential",
                nextStepForCustomer: "Nächste Schritte",
                suitableForEmailCampaign: "Geeignet für proaktive Ansprache",
                language: "Sprache",
                qualificationStatus: "Qualifizierungs-Status",
                interactionStatus: "Interaktions-Status",
                email_bounce: "Email senden fehlgeschlagen", // Email bounces
                email_verified: "Email verifiziert", // Email verified
                advertisement_consent: "Einwilligung zur Werbung", // Advertisement consent
                advertisement_ban: "Werbeverbot",
                is_control_group: "Ist Kontrollgruppe", // Is control group
                last_interaction_date: "Letztes Interaktionsdatum", // Last interaction date
                entityType: "Typ",
                responsible: "Account-Manager", 
                source: "Lead-Quelle",
                referrer: "Referrer"
            },
            interaction: "Kundeninteraktion",
            options: {
                qualificationStatus: {
                    mql: "MQL",
                    sql: "SQL",
                    blocked: "Keine Kommunikation"
                },
                interactionStatus: {
                    new: "Neu",
                    contactAttempted: "Kontaktaufnahme versucht",
                    contactWithPotential: "Kontakt mit Potenzial",
                    pause: "Erstmal nich mehr anrufen",
                    badTiming: "Schlechtes Timing",
                    openDeal: "Offener Deal",
                    customer: "Kunde",
                    parked: "Geparkt",
                    disqualified: "Disqualifiziert"
                },
                entityType: {
                    all: "Alle",
                    person: "Person",
                    company: "Firma"
                },
                sourceType: {
                    linkedIn: "LinkedIn",
                    flyer: "Flyer",
                    friend: "FreundIn",
                    mail: "E-Mail",
                    google: "Google",
                    instagram: "Instagram",
                    magazine: "Magazin",
                    source: "Quelle",
                }
            },    
            sendEmail: "Email Senden",        
            alert: {
                isDeleted: "Dieser Kontakt ist gelöscht"
            }
        },
        customers: {
            emptyList: "Keine Kontakte gefunden",
            emptyListTab: "Keine Kontakte in \"{{tab}}\" gefunden",
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                user_id: "Owner für alle {{selected}} ändern",
                contact_type: "Kategorie für alle {{selected}} ändern",
                is_verified: "Verifikations-Status für alle {{selected}} ändern",
                delete: "Alle {{selected}} löschen",
            },
            new: "Neuer Kunde",
            search: {
                button: "Kunden Suchen",
                placeholder: "Suchen..."
            },
            tab: {
                all: "Verifizierte Kontakte",
                prospect: "Interessenten",
                customer: "Kunden",
                colleague: "Kollegen",
                partner: "Partner",
                supplier: "Zulieferer",
                applicant: "Bewerber",
                deleted: "Gelöscht",
                duplicate: "Dubletten",
                blocked: "Nicht-Kunden",
            },
            table: {
                user_id: "Owner",
                contact_type: "Kategorie",
                firstname: "Vorname",
                lastname: "Nachname",
                companyName: "Firmenname",
                position: "Position",
                is_verified: "Verifikation",
                select: "Auswählen", 
                delete: "",
                workflow_status: "",
                referred_by_contact_id: "Referrer",
                latest_order_date: "Order"
            },
            upload: "Kunden hochladen",
        },
        communication_plans: {
            add: "Kommunikationsplan Anlegen",
            new: "Kommunikationsplan Anlegen",
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                status: "Status für alle {{selected}} ändern",
                delete: "Alle {{selected}} löschen",
            },
            emptyList: "Kein Kommunikationsplan gefunden.",
            emptyListTab: "Keine Kommunikationspläne in \"{{tab}}\" gefunden",
            channels: {
                email: "eMail Kommunikation hinzufügen",
                sms: "SMS Kommunikation hinzufügen",
                whatsapp: "Whatsapp Kommunikation hinzufügen",
                signal: "Kommunikation über Signal Messanger hinzufügen",
                event: "Ein Event hinzufügen",
                training: "Ein Training hinzufügen",
                linkedin: "LinkedIn Kommunikation hinzufügen",
            },
            label: {
                name: "Name",
                event_response: "Reaktion auf Kundeninteraktion",
                description: "Beschreibung",
                status: "Status",
            },
            tab: {
                all: "Alle",
                deleted: "Gelöschte Kommunikationspläne",
            },
            table: {
                select: "Auswählen",
                name: "Name",
                description: "Beschreibung",
                status: "Status",
                delete: ""
            },
            search: {
                placeholder: "Suche..."
            },
            select: "Kommunikationsplan Auswählen"            
        },
        communication_steps: {
            label: {
                name: "Name",
                type: "Kommunikationsart",
                is_customized: "Die Kommunikation individualisieren für die einzelnen Empfänger?",
                customization_sources: "Informationsquellen für die Individualisierung",
                status: "Status",
                subject: "Kommunikations-Betreff",
                content: "Kommunikations-Inhalt",
            },       
        },
        companyRelation: {
            add: "Position hinzufügen",
            companiesTitle: "Position",
            employeesTitle: "Mitarbeiter",
            label: {
                person: "Mitarbeiter Detailansicht",
                company: "Firmen-Detailansicht",
                relationType: "Beziehung",
                position: "Position",
                department: "Abteilung",
                startDate: "Beginn",
                endDate: "Ende"
            }
        },
        crossSell: {
            label: {
                source_product_id: "Quellprodukt-ID",
                target_product_id: "Zielprodukt-ID",
                probability: "Wahrscheinlichkeit",
                trigger_after_mins: "Trigger nach (Minuten)",
                type: "Typ",
                is_active: "Aktiv",
                target_image_url: "Vorschau Zielprodukt",
                selectTargetProduct: "Ziel-Produkt auswählen"
            },
            options: {
                type: {
                    upsell: "Up Sell",
                    crosssell: "Cross Sell",
                    repurchase: "Wiederkauf"
                },
            },
            title: "Cross-Sell-Produkte",
            button: {
                addCrossSell: "Cross-Sell hinzufügen"
            }
        },          
        detailView: {
            noItemSelected: "Kein Element ausgewählt"
        },
        documents: { 
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen",
            },
            tab: {
                all: "Alle Dokumente",
                deleted: "Gelöschte 'Dokumente'"
            },
            search: {
                placeholder: "Suche..."
            },
            label: "Dokumente",
            table: {
                select: "Auswählen",
                document_type: 'Dokumententyp',
                language: 'Sprache',
                category: 'Kategorie',
                status: 'Status',
                owner_user_id: 'Nutzer',
                issued_at: 'Ausstellungsdatum',
                expires_at: 'Ablaufdatum',
                monthly_amount: 'Betrag',
                case_number: "Fallnummer",
                delete: ""
            },
            emptyList: "Keine Dokumente gefunden",
            emptyListTab: "Keine Dokumente in \"{{tab}}\" gefunden",
            label: {
                document_type: 'Dokumententyp',
                language: 'Sprache',
                category: 'Kategorie',
                status: 'Status',
                owner_user_id: 'Nutzer',
                upload_id: 'Original Dokument',
                expires_at: 'Ablaufdatum',
                issued_at: 'Ausstellungsdatum',
                user_provided_data: 'Enthaltene Information',
                case_number: "Fallnummer",
                monthly_amount: "Monatliche Zahlung",   
            },
            new: "Neues Dokument anlegen",
            upload: "Dokument hochladen",
            options: {
                document_type: {
                    bescheid: "Bescheid",
                    nachfragevomamt: "Nachfrage vom Amt",
                    nachfrageansamt: "Nachfrage ans Amt",
                    antrag: "Antrag"
                },
                category: {
                    kindergeld: "Kindergeld",
                    bürgergeld: "Bürgergeld",
                    bildungundteilhabe: "Bildung und Teilhabe",
                    wohngeld: "Wohngeld",
                    kinderzuschlag: "Kinderzuschlag",
                    unterhaltsvorschussgesetz: "Unterhaltsvorschussgesetz",
                    kinderbetreuung: "Kinderbetreuung",
                    aufenthaltserlaubnis: "Aufenthaltserlaubnis"
                }
            }
        },
        email: {
            action: {
                edit: "Bearbeiten"
            },
            alert: {
                delete: "E-Mail wird gelöscht",
                fail: "Email senden fehlgeschlagen",
                recalc: "Email wird überarbeitet...",
                recalcSuccess: "Email Überberarbeitung abgeschlossen",
                sent: "Email gesendet",
                unread: "Markiere email als ungelesen",
                sending: "Senden..."
            },
            analytics: {
                noAnalyticsTitle: "Keine Analyse Verfügbar",
                wait: "Die eMail wurde noch nicht analysiert",
                noAnalysisNeeded: "Eine Analyse scheint für diese email nicht nötig",
                error: "Die eMail konnte nicht analysiert werden",
                analyze: "Analysiere",
                noAnalysis: "Keine Analyse verfügbar",
                notVerified: "Der Sender ist nicht als Kunde verifiziert",
                noAnalysisDesc: "Es tut mir Leid, ich konnte diese eMail leider nicht analysieren.",
                shouldAnalyze: "Email analysieren?",
                analyzeThis: "Diese Email Analysieren",
                allAnalyzed: "Aktuell werden alle emails dieses Kontakts analysiert.", 
                analyzeContact: "Alle Emails dieses Kontakts analysieren", 
                noneAnalyzed: "Aktuell werden keine emails dieses Kontakts analysiert.",
                blockContact: "Keine Emails dieses Kontakts analysieren",
            },
            analyticsStatus: {
                ANALYZED: "Analysiert",
                NO_ANALYSIS_NEEDED: "Keine Analyse geplant",
                ERROR: "Analyse nicht möglich",
                NOT_ANALYZED: "Noch nicht analysiert",
                SENDER_NOT_VERIFIED: "Analyse für diesen Kontakt nicht aktiviert",
                SENDER_BLOCKED: "Analyse für diesen Kontakt deaktiviert"
            },
            assistant: {
                tab: {
                    answer: "Antworten",
                    discuss: "Diskutieren",
                    understand: "Verstehen",
                    customer: "Überblick",
                    write: "Schreiben",
                }
            },
            button: {
                extend: "Erweiterte Empfängerinformationen"
            },
            confirmationModal: {
                title: "Email Senden",
                missingToAddress: "Die eMail hat keinen gültigen Addressaten.",
                missingSubject: "Die eMail hat keinen Betreff. Trotzdem senden?",
                missingBody: "Die eMail hat keinen Inhalt. Trotzdem senden?",
                send: "Trotzdem Senden"
            },
            event:{
                Organizer: "Veranstalter",
                Starts: "Beginnt",
                Ends: "Endet",
                Location: "Ort",
                Attendee: "Teilnehmer",
                NoLocation: "Kein Ort",
                NoAttendee: "Kein Teilnehmer"
            },
            options: {
                workflowStatus: {
                    all: "Alle",
                    new: "Neu",
                    in_progress: "In Arbeit",
                    done: "Fertig",
                    archieved: "Archiviert"
                }
            },
            regards: "Viele Grüße",
            schedule: {
                sending: "Email wird gesendet...",
                timeLabel: "Senden geplant für:",
                canceling: "Email wird storniert...",
                cancelScheduledTime: "Geplante Zeit stornieren",
                confirmCancelScheduledTime: "Sind sie sicher, dass sie die geplante Zeit stornieren möchten?"
            },
            label: {
                to: "An:",
                ccs: "CC:",
                bccs: "BCC:",
                from: "Von:",
                subject: "Betreff:",
                time: "Versandzeit:",
                acceptSuggestedTime: "Vorschlag annehmen",
                rejectSuggestedTime: "Vorschlag ablehnen"
            },
            scheduleWarning: {
                weekend: "Sende-Zeit fällt auf ein Wochenende.",
                outsideBusinessHours: "Sende-Zeit außerhalb der Geschäftszeiten."
            },
            prompt: {
                answer: 'Prompt für das Beantworten von eMails',
                analysis: 'Prompt für die eMail analyse'
            },
            separator: {
                at: "Am",
                wrote: "schrieb"
            },
            sendAll: "An alle senden"
        },
        account_settings: {
            connect: "Account Verbinden",
            disConnect: "Account Löschen",
            refresh: "Aktualisieren",
            headline: "Kommunikationskanäle",
            emptyList: "Keine E-Mail-Einstellungen gefunden",
            emptyListTab: "Keine Einstellungen in \"{{tab}}\" gefunden",
            label: {
                email: "E-Mail",
                username: "Benutzername",
                from_name: "Absendername",
                imap: "IMAP-Server",
                smtp: "SMTP-Server",
                is_active: "Aktiv",
                is_deleted: "Gelöscht",
                is_default: "Standard",
                check_spam: "Spam-Prüfung",
                spam_threshold: "Spam-Schwelle",
                email_analysis_days_back: "Analysezeitraum (Tage)",
                email_download_start_date: "Download-Startdatum",
                auth_method: "Authentifizierungsmethode",
                logo_upload_id: "Logo Upload ID",
                password: "Passwort",
                logo: "Logo",
                channel: "Kanal"
            },
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen"
            },
            new: "Neue E-Mail-Einstellung",
            options: {
                channels: {
                    email: "Email",
                    linkedin: "linkedIn",
                    whatsapp: "Whatsapp",
                }
            },
            search: {
                button: "Einstellung suchen",
                placeholder: "Suchen..."
            },
            status: {
                ok: "OK",
                error: "Disconnected",
            },
            tab: {
                all: "Alle Einstellungen",
                deleted: "Gelöschte Einstellungen"
            },
            table: {
                select: "Auswählen",
                email: "E-Mail",
                username: "Benutzername",
                from_name: "Absendername",
                imap: "IMAP",
                smtp: "SMTP",
                auth_method: "Authentifizierung",
                is_active: "Aktiv",
                delete: ""
            },
            upload: "Einstellungen hochladen"
        },
        event_participants: {
            search: {
                placeholder: "Suche..."
            },
            emptyList: "Keine Event-Teilnehmer gefunden",
            emptyListTab: "Keine Event-Teilnehmer in \"{{tab}}\" gefunden",
            label: {
                status: "Status",
                event_id: "Event",
                contact_id: "Kontakt",
                email_id: "Email",
                created_at: "Erstellt am",
                planned_date: "Geplanter Termin",
            },
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen",
            },
            new: "Neuen Event-Teilnehmer anlegen",
            options: {
                status: {
                    inCreation: "In Erstellung",
                    done: "Erledigt",
                    open: "Offen",
                    pause: "Pausiert",
                    running: "In Bearbeitung",
                    failed: "Fehlgeschlagen",
                }
            },
            upload: "Event-Teilnehmer hochladen",
            tab: {
                all: "Alle Event-Teilnehmer",
                deleted: "Gelöscht"
            },
            title: "Event-Teilnehmer",
            table: {
                select: "Auswählen",
                type: "Typ",
                contact_id: "Kontakt",
                event_id: "Kampagne",
                status: "Status",
                planned_date: "Geplanter Termin",
                created_at: "Erstellt",
                delete: ""
            }
        },             
        events: {
            emptyList: "Keine Kampagnen gefunden",
            emptyListTab: "Keine Kampagnen in \"{{tab}}\" gefunden",
            filterTree: {
                addressField: {
                    streetFilter: "Straßenfilter",
                    cityFilter: "Stadtfilter",
                    stateFilter: "Bundeslandfilter",
                    postalCodeFilter: "Postleitzahlenfilter",
                    countryFilter: "Länderfilter",
                },
                create: "Filterbaum Erstellen",
                title: "Teilnehmer Auswählen",
                addFilters: "Filter hinzufügen",
                nodeTypes: {
                    audience: "Alle potentiellen Teilnehmer ohne Filterung"
                },
                button: {
                    add: "Filter hinzufügen",
                    validEmailAddress: "Teilnehmer mit gültiger eMail-Adresse",
                    noDoubleCommunication: "Keine Mehrfach-Kommunikation",
                    advertisingPermission: "Nur mit Werbeerlaubnis",
                    executeTree: "Filter anwenden",
                    AddressFilter: "Adressfilter",
                    Category: "Kategorie",
                    advertisingBan: "Werbeverbot",
                },
                description: {
                    keepAll: "Dieser Filter lässt alle Teilnehmer durch, ohne eine Einschränkung oder Filterung vorzunehmen.",
                    validEmailAddress: "Dieser Filter schließt Teilnehmer aus, deren eMail-Adresse ungültig zurückgewiesen wurde.",
                    noDoubleCommunication: "Dieser Filter schließt Teilnehmer aus, die innerhalb einer konfigurierbaren Zeitspanne kontaktiert wurden.",
                    advertisingPermission: "Dieser Filter umfasst nur Teilnehmer, die eine gültige Werbeerlaubnis erteilt haben.",
                    postalCode: "Dieser Filter beschränkt die Teilnehmer basierend auf der Adresse. Nutzen Sie % als wild card, zum Beispiel 022% für PLZ starten mit 022",
                    category: "Dieser Filter selektiert Teilnehmer basierend auf ihrer Kategorie. Sie können eingeschlossen oder ausgefiltert werden.",
                    advertisingBan: "Dieser Filter schließt Teilnehmer aus, die ein Werbeverbot ausgesprochen haben.",
                },        
                label: {
                    filter_id: "Filter-ID",
                    filterDays: "Filter-Tage",
                    filterField: "Filterfeld",
                    filterValue: "Filterwert",
                    filterOut: "Filter umkehren",
                },
                errors: {
                    configIncomplete: 'Konfiguration unvollständig'
                },
                updateSuccess: "Filter aktualisiert",
                updateFilter: "Filter {{current}} von {{total}} berechnet"
            },
            info: {
                title: "Überblick"
            },  
            label: {
                description: "Beschreibung",
                name: "Name",
                type: "Typ",
                start_date: "Startdatum",
                end_date: "Enddatum",
                created_at: "Erstellungsdatum",
                updated_at: "Letztes Update",
                status: "Status",
                max_capacity: "Maximale Kapazität",
                communication_plan_id: "Kommunikationsplan",
            },
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                type: "Typ für alle {{selected}} ändern",
                status: "Status für alle {{selected}} ändern",
                delete: "Alle {{selected}} löschen",
            },
            new: "Neue Veranstaltung",
            phonePanel: {
                title: "Telefon-Kampagne",
                status: {
                    done: "Erledigt",
                    failed: "Nicht Erreicht"
                }
            },
            no_end_date: "Kein Enddatum",
            scheduler: {
                title: "Zeitplanung"
            },
            search: {
                button: "Veranstaltung suchen",
                placeholder: "Suchen..."
            },
            warn: {
                addParticipants: "Bitte fügen Sie Teilnehmer zur Kampagne hinzu",
                selectCommunicationPlan: "Bitte wählen Sie einen Kommunikationsplan",
            },
            tab: {
                all: "Alle Veranstaltungen",
                upcoming: "Anstehende Veranstaltungen",
                deleted: "Gelöschte Veranstaltungen"
            },
            table: {
                select: "Auswählen",
                description: "Beschreibung",
                name: "Name",
                type: "Typ",
                start_date: "Startdatum",
                end_date: "Enddatum",
                status: "Status",
                max_capacity: "Maximale Kapazität",
                delete: ""
            },
            type: {
                email: 'e-Mail',
                phone: 'Telefon',
                workshop: 'Workshop',
                webinar: 'Webinar',
                demo: 'Demo',
                training: 'Training'
            },
            status: {
                planned: 'Geplant',
                running: 'Läuft',
                finished: 'Abgeschlossen',
                canceled: 'Abgebrochen'
            },
            unlimited_capacity: "Unbegrenzte Kapazität",
            upload: "Veranstaltungen hochladen"
        },    
        emails: {
            dropdown:{
                allAccountSettings: "Alle Email Adressen",
                selectAccountSetting: "Wählen Sie eine eMail Adresse"
            },
            emptyList: "Keine Emails gefunden",
            emptyListTab: "Keine Email in \"{{tab}}\" gefunden",
            filter: {
                owner: "Owner",
                workflow_status: "Status",
                account_settings: "Email Adresse",
                workflow_status_exclude: "Status ausblenden"
            },
            label: "Emails",
            search: {
                placeholder: "Suchen..."
            },
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                owner_user_id: "Owner für alle {{selected}} ändern",
                workflow_status: "Status für alle {{selected}} ändern",
                delete: "Alle {{selected}} löschen",
                isRead: "Alle {{selected}} als gelesen markieren",
            },
            scheduler: {
                refresh: "Teilnehmer-Daten updaten",
                start: "Email-Kampagne-Starten",
                pause: "Kampagne pausieren",
                stop: "Kampagne stoppen",
                checkAndDeleteDuplicates: "Dubletten Check",
                confirmCheckAndDeleteDuplicates: "Sind Sie sicher, dass Sie einene Dubletten Check durchführen möchten? Emails werden auf Basis des Betreff verglichen. Doppelte emails werden gelöscht.",
                confirmStart: "Sind Sie sicher, dass Sie diese E-Mail-Kampagne versenden möchten? Bitte überprüfen Sie alle Details sorgfältig, bevor Sie fortfahren, da diese Aktion Kundenkommunikation auslösen kann.",
                confirmPause: "Sind Sie sicher, dass Sie diese E-Mail-Kampagne pausieren möchten?",
                confirmStop: "Sind Sie sicher, dass Sie diese E-Mail-Kampagne stoppen möchten?",
            },
            tab: {
                all: "Alle empfangenen Emails",
                deleted: "Gelöscht",
                sent: "Gesendet",
                unread: "Ungelesen",
                draft: "Entwürfe",
                suggested: "Vorschläge",
                scheduled: "Geplant",
                mixed: "Gemischt"
            },
            table: {
                select: "Auswählen",
                owner_user_id: "Owner",
                workflow_status: "Status",
                date: "Emfangsdatum",
                dateMixed: "Datum",
                from_name: "Sender",
                subject: "Betreff",
                sentDate: "Gesendet",
                sendDate: "Geplant",
                createDate: "Erstellungsdatum",
                approve: "Freigeben",
                reject: "Zurückweisen",
                to: "An",
                delete: "",
                isRead: "",
                direction: ""
            },
            toolbar: {
                back: "Zur eMail Liste",
                delete: "eMail löschen",
                unread: "Als ungelesen markieren",
                reply: "Antworten",
                toggleAIPanel: "AI Panel öffnen / schließen",
                undo: "Texteingabe rückgängig machen",
                redo: "Texteingabe wiederholen",
                attach: "Anhang hinzufügen",
                emailView: "Zur Email-Ansicht",
                calendarView: "Zur Kalender-Ansicht",
                original: "Zur vorherigen Nachricht",
                massEmail: "Massen-eMail",
                individualEmail: "Individuelle eMail"
            },
            ai: {
                general_task: "Änderungswunsch für diese und alle künftigen eMails",
                recalculate: "Schreibe eine email",
                reformulate: "Änderungswunsch für diese eMail",
                send: "eMail absenden",
                speak: "Kommando einsprechen"
            },
            new: "Neue Email schreiben",
            sent: "Email Submitted",
            upload: "Emails hochladen",
        },
        emailAddress: {
            title: "Weitere Email-Adressen", 
            add: "Email-Adresse Hinzufügen",
            label: {
                email_address: "Email-Adresse",
                email_type: "Bezeichnung",
                is_primary: "Primäre Email-Adresse"
            }
        },
        emailEdit: {
            button: {
                empty: "Discard Suggestion"
            },
            options: {
                formality: {
                    informal: "Informal",
                    formal: "Formal"
                },
                tone: {
                    angry: "Angry",
                    playful: "Playful",
                    friendly: "Friendly",
                    professional: "Professional",
                    empathetic: "Empathetic",
                    neutral: "Neutral"
                },
                levelOfDetail: {
                    brief: "Brief",
                    detailed: "Detailed",
                    stepByStep: "Step-by-step",
                    overview: "Overview",
                    comprehensive: "Comprehensive"
                },
                cta: {
                    replyRequired: "Reply Required",
                    clickLink: "Click Link",
                    provideFeedback: "Provide Feedback",
                    scheduleMeeting: "Schedule Meeting",
                    makePayment: "Make Payment"
                }
            },
            considerNot: {
                customer: "DO NOT use AI analysis of the customer",
                notes: "DO NOT use notes",
                knowledge: "DO NOT use knowledge"
            },
            consider: {
                customer: "Use AI analysis of the customer",
                notes: "Use notes",
                knowledge: "Use knowledge"
            },
            label: {
                formality: "Formality",
                tone: "Tone",
                purpose: "Purpose",
                levelOfDetail: "Detail Level",
                cta: "Call to Action",
                template: "Template",
                language: "Language"
            },
            sections: {
                aiControl: "Update Email with AI"
            }
        },
        emailInputBar: {
            add: "{{key}} hinzufügen",
            placeholder: "Addressat hinzufügen...",
            emptyResult: "Keine Ergebnisse gefunden"
        },
        emailScheduler: {
            header: {
                preview: "Scheduling Preview"
            },
            labels: {
                count: "#",
                dateTime: "Datum und Zeit",
                name: "Name",
                email: "Email",
                phone: "Telefonnummer",
                status: "status",
                notPlanned: "..."
            },
            input: {
                earliestTime: "Keine E-Mails senden vor...",
                latestTime: "Keine E-Mails senden nach...",
                emailsPerHour: "Nicht mehr E-Mails pro Stunde senden als...",
                dailyEmailLimit: "Nicht mehr E-Mails pro Tag senden als...",
                update: "Aktualisieren"
            },
            noParticipants: "Keine Teilnehmer gefunden"
        },
        emoticonPicker: {
            pick: "Icon Wählen"
        },
        eventCommunication: {
            header: {
                preview: "Kommunikation"
            },
            labels: {
                count: "#",
                dateTime: "Datum und Zeit",
                name: "Name",
                email: "Email",
                status: "Status"
            },
        },
        error: {
            authentication: "Ein Fehler ist bei der Authentifizierung aufgetreten",
            loadingSettings: "Ein Fehler ist beim Laden der Benutzereinstellungen aufgetreten",
            errorPage: {
                title: "Seite nicht gefunden",
                message: "Ein Fehler ist aufgetreten. Bitte überprüfen Sie Ihre Internetverbindung."
            },
            apiError: {
                title:"Wir haben ein Problem.",
                message: "Wir haben Probleme mit der Verbindung. Bitte versuche es noch einmal."
            },
            duplicateRecord: "Dubletten sind nicht zulässig",
            noAccess: {
                title: "Kein Zugriff",
                message: "Sie haben keinen Zugriff auf die Angefragte Anwendung. Bitte wenden Sie sich an Ihren Administrator."
            },
            noVideoSupport: "Ihr Browser unterstütz keine Videos.",
            action: {
                retry: "Wiederholen"
            },
            unsupportedMedia: "Keine Vorschau verfügbar",
            contactAdminButton: "Administrator kontaktieren",
            invalidAccessRule: "Ungültige Zugriffsregel",
            invalidJson: "Ungültiges Json"
        },
        feedback: {
            submit: "Feedback teilen"
        },
        homeButton: "Zur Startseite",
        import: {
            alert: {
                error: "Fehler in der Importdatei",
                exporting: "Der Gesprächsleitfaden wird exportiert",
                updating: "Uploading"
            }, 
            title: "Import Vorschau",
            type:{
                Person: "Kontakt",
                Address: "Addresse",
                addresses: "Adressen",
                companies: "Firmen",
                company_financials: "Finanzdaten"
            },
            label: {
                primary: "Primäres Objekt"
            }
        },
        import_data: {
            search: {
                placeholder: "Suche..."
            },
            emptyList: "Keine Importdaten gefunden",
            emptyListTab: "Keine Importdaten in \"{{tab}}\" gefunden",
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen",
            },
            new: "Neue Importdaten anlegen",
            upload: "Importdaten hochladen",
            tab: {
                all: "Alle Importdaten",
                deleted: "Gelöscht"
            },
            title: "Importdaten",
            table: {
                select: "Auswählen",
                upload_id: "Upload",
                name: "Name",
                type: "Typ",
                status: "Status",
                records_imported: "Importierte Datensätze",
                records_failed: "Fehlgeschlagene Datensätze",
                is_primary: "Primär",
                is_deleted: "Gelöscht",
                delete: ""
            }
        },        
        interaction: {
            done: "Fertig",
            showDetails: "Alle Details anzeigen",
            title: "Kundeninteraktionen",
            add: "Weitere Interaktion dokumentieren",
            provideSummary: "Interaktions-Zusammenfassung",
            label: {
                id: "ID",
                type: "Typ der Interaktion",
                tags: "Tags",
                summary: "Zusammenfassung",
                call_direction: "Anrufrichtung",
                contact_id: "Kontakt-ID",
                related_contacts: "Zugehörige Kontakte",
                user_id: "Benutzer-ID",
                outcome: "Ergebnis",
                recording_url: "Aufzeichnungs-URL",
                transcript: "Transkript",
                status: "Status",
                phone_number: "Telefonnummer",
                start_time: "Startzeit",
                end_time: "Endzeit",
                duration: "Dauer",
                tenant_id: "Mandanten-ID",
                is_deleted: "Gelöscht",
                created_at: "Erstellt am",
                updated_at: "Aktualisiert am"
            },
            option: {
                call: "Anruf",
                video_call: "Videoanruf",
                in_person: "Persönlich",
                inbound: "Eingehend",
                outbound: "Ausgehend",
                scheduled: "Geplant",
                completed: "Abgeschlossen",
                missed: "Verpasst",
                canceled: "Abgesagt",
                in_progress: "In Bearbeitung",
                ordered: "Bestellt",
                request_more_information: "Weitere Informationen angefordert",
                customer_not_interested: "Kunde nicht interessiert",
                follow_up_scheduled: "Folgeanruf geplant",
                converted_to_opportunity: "In Verkaufschance umgewandelt",
                issue_resolved: "Problem gelöst",
                pending_decision: "Entscheidung ausstehend",
                escalated: "Eskalation",
                no_show: "Nicht erschienen",
                referred: "Weitergeleitet",
                complaint_logged: "Beschwerde protokolliert"
            },
            type: "Typ",
            tags: "Stichworte",
            summary: "Zusammenfassung",
            call_direction: "Anrufrichtung",
            contact: "Primärer Kontakt",
            related_contacts: "Weitere Kontakte",
            user: "Benutzer",
            outcome: "Ergebnis",
            recording_url: "Aufzeichnungs-URL",
            transcript: "Transkript",
            status: "Status",
            phone_number: "Telefonnummer",
            start_time: "Startzeit",
            end_time: "Endzeit",
            duration: "Dauer",
            created_at: "Erstellt am",
            updated_at: "Aktualisiert am"
        },
        integrations: {
            emptyList: "Keine Integrationen gefunden",
            emptyListTab: "Keine Integrationen in \"{{tab}}\" gefunden",
            label: {
                name: "Name",
                endpoint: "Endpoint",
                description: "Beschreibung",
                method: "Methode",
                auth_required: "Authentifizierung erforderlich",
                response_format: "Antwortformat",
                enabled: "Aktiv",
                interval: "Intervall",
                last_run_at: "Letzter Lauf",
                last_processed_key: "Letzter Schlüssel",
                is_deleted: "Gelöscht",
                created_at: "Erstellungsdatum",
                secret: "Secret"
            },
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen"
            },
            new: "Neue Integration",
            search: {
                button: "Integration suchen",
                placeholder: "Suchen..."
            },
            tab: {
                all: "Alle Integrationen",
                deleted: "Gelöschte Integrationen"
            },
            table: {
                select: "Auswählen",
                name: "Name",
                endpoint: "Endpoint",
                method: "Methode",
                enabled: "Aktiv",
                last_run_at: "Letzter Lauf",
                delete: ""
            },
            upload: "Integrationen hochladen"
        },        
        interactions: {
            search: {
                placeholder: "Suche..."
            },
            emptyList: "Keine Interaktionen gefunden",
            emptyListTab: "Keine Interaktionen in \"{{tab}}\" gefunden",
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                user_id: "Autor für alle {{selected}} ändern",
                delete: "Alle {{selected}} löschen",
            },
            new: "Neue Interaktion anlegen",
            upload: "Interaktionen hochladen",
            label: "Interaktionen",
            tab: {
                all: "Alle Interaktionen",
                deleted: "Gelöschte Interaktionen"
            },
            title: "Titel",
            table: {
                select: "Auswählen",
                type: "Typ",
                tags: "Tags",
                contact_id: "Kontakt",
                user_id: "Autor",
                status: "Status",
                created_at: "Erstellt",
                delete: ""
            },
            toolbar: {
                call: "Anruf starten"
            }
        },   
        knowledge: {
            addKnowledge: "Hintergrundwissen anlegen",
            emptyList: "Kein Hintergrundwissen gefunden",
            emptyListTab: "Kein Hintergrundwissen in \"{{tab}}\" gefunden",
            ignore: "Ignorieren",
            label:{
                id: "ID",
                topic: "Thema",
                keywords: "Schlüsselwörter",
                source: "Quelle",
                created_at: "Erstellt am",
                updated_at: "Letztes Update",
                source_section: "Quellabschnitt",
                is_active: "Ist Aktiv",
                type: "Typ",
                prompt: "Analyse-Anweisung"
            },
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen",
            },
            msg: {
                processing: 'Die Daten werden verarbeitet. Das kann etwas dauern...'
            },
            new: "Neues Hintergrundwissen anlegen",
            noLinesAvailable: "Es ist kein Hintergrundwissen konfiguriert",
            plain: "Original Text",
            summary: "Zusammenfassung",
            title: "Hintergrundwissen",
            updated: "Zusammenfassung erstellt",
            updating: "Zusammenfassung wird erstellt",
            table: {
                select: "Auswählen",
                topic: 'Thema',
                keywords: 'Schlüsselwörter',
                created_at: 'Erstellt Am',
                updated_at: "Letztes Update",
                is_active: 'Aktiv',
                delete: ""
            },
            search: {
                placeholder: "Suche..."
            },
            tab: {
                all: "Alle",
                deleted: "Gelöscht"
            }
        },
        lineItem: {
            label: {
                product_id: "Produkt-ID",
                type: "Typ",
                quantity: "Menge",
                list_price: "Listenpreis",
                unit_price: "Stückpreis",
                description: "Beschreibung",
                created_at: "Erstellt am",
                delivery_date: "Lieferdatum",
                expires_at: "Ablaufdatum"
            },
            options: {
                type: {
                    sales: "Verkauf",
                    subscription: "Abonnement",
                    rent: "Miete"
                }
            },
            title: "Positionen",
            button: {
                addLineItem: "Position hinzufügen"
            }
        },
        link: {
            label: {
                home: "Zur Homepage"
            }
        },
        linkedin_actions: {
            search: {
                placeholder: "Suche..."
            },
            dashboard: "Dashboard",
            emptyList: "Keine LinkedIn-Aktionen gefunden",
            emptyListTab: "Keine LinkedIn-Aktionen in \"{{tab}}\" gefunden",
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                contact_id: "Kontakt für alle {{selected}} ändern",
                delete: "Alle {{selected}} löschen",
            },
            new: "Neue LinkedIn-Aktion anlegen",
            upload: "LinkedIn-Aktionen hochladen",
            label: {
                list: "LinkedIn-Aktionen",
                action_type: "Aktionstyp",
                parameters: "Parameter",
                contact_id: "Kontakt",
                status: "Status",
                scheduled_at: "Geplant für",
                execute_at: "Ausführen am",
                error_message: "Fehlermeldung",
                result: "Ergebnis"
            },
            option: {
                actionType: {
                    research_profile: "Profil recherchieren",
                    send_invitation: "Einladung senden",
                    send_message: "Nachricht senden",
                    get_messages: "Nachrichten abrufen"
                },
                status: {
                    new: "Neu",
                    scheduled: "Geplant",
                    in_execution: "Wird ausgeführt",
                    success: "Erfolg",
                    failed: "Fehlgeschlagen"
                }
            },
            tab: {
                all: "Alle LinkedIn-Aktionen",
                deleted: "Gelöschte LinkedIn-Aktionen"
            },
            title: "Titel",
            table: {
                select: "Auswählen",
                action_type: "Aktionstyp",
                contact_id: "Kontakt",
                status: "Status",
                scheduled_at: "Geplant",
                execute_at: "Ausführen",
                delete: ""
            }
        },        
        list: { 
            deselectAll: "Alle Abwählen",
            selectAll: "Alle auswählen",
            showFilters: "Filter anzeigen",
            hideFilters: "Filter ausblenden",
            total: "Gesamtzahl",
            noTab: "In allen Tabs Suchen"
        },
        log_center: "Aktivitäten",
        log: {
            table: {
                source: "Modul",
                created_at: "Zeit",
                message: "Meldung"
            },
            search: {
                placeholder: "Suche"
            },
            emptyList: "Keine Log Messages gefunden",
        },
        login: {
            register: "Registrieren",
            button: "Anmelden",
            title: "Mainition CRM Automation",
            invitationHeadline: "Wilkommen!",
            invitationSubline: "Ihre Einladung wird geprüft...",
            errorToken: "Keine gültige Einladung gefunden"
        },
        menu: {
            ai_control: "KI Einstellungen",
            avatars: "Avatare",
            bank_accounts: "Bank Accounts",
            chat_designs: "Chat Designs",
            chat_sessions: "Chat Sitzungen",
            chats: "Chats",
            companies: "Firmen",
            communication_plans: "Kommunikationspläne",
            contact_relationships: "Beziehungen",
            contracts: "Verträge",
            crm: "Kontaktpflege",
            customers: "Kontakte",
            dashboard: "Dashboard",
            documents: "Dokumente",
            account_settings: "E-Mail Einstellungen",
            emails: "E-Mails",
            events: "Kampagnen",
            event_participants: "Event-Teilnehmer",             
            import_data: "Importierte Daten",                   
            interactions: "Interaktionen",
            integrations: "Integrationen",
            knowledge: "Bibliothek",
            languagePictureAlt: "Aktuelle Sprachflagge: Deutsch",
            linkedin_actions: "Linkedin",
            logout: "Abmelden",
            marketing: "Massenansprache",
            message_templates: "Templates",
            metadata: "Metadaten",                              
            notes: "Notizen",
            oms: "Order Management",
            orders: "Bestellungen",
            products: "Produkte",
            profile: "Profil",
            profilePictureAlt: "Profilbild",
            prompts: "Prompts",                               
            roles: "Rechte / Rollen",
            searchPlaceholder: "SUCHEN",
            settings: "Einstellungen",
            settingsWizard: "Einstiegs-Setup",
            signatures: "Signaturen",
            social_media_accounts: "Social Media Accounts",
            switchApp: "App Wechseln",
            tenants: "Tenants",
            term_corrections: "Korrekturen",                    
            todos: "Todos",
            training: "KI Training",
            uploads: "Uploads",
            users: "Nutzer",
            savvyspeak: "SavvySpeak",
            speicherfuchs: "Speicherfuchs",
            unknown: "Wilkommen"
        },             
        message_templates: {
            emptyList: "Keine Nachrichtenvorlagen gefunden",
            emptyListTab: "Keine Nachrichtenvorlagen in \"{{tab}}\" gefunden",
            new: "Neue Nachrichtenvorlage",
            search: {
                button: "Vorlage suchen",
                placeholder: "Suchen..."
            },
            tab: {
                all: "Alle Vorlagen",
                deleted: "Gelöschte Vorlagen"
            },
            label: {
                title: "Titel",
                subject: "Betreff",
                body: "Nachrichten Inhalt",
                category: "Kategorie",
                created_at: "Erstellt am",
                updated_at: "Letztes Update",
                is_active: "Aktivstatus"
            },
            table: {
                title: "Titel",
                subject: "Betreff",
                category: "Kategorie",
                created_at: "Erstellt am",
                updated_at: "Letztes Update",
                is_active: "Aktivstatus",
                delete: ""
            },
            upload: "Nachrichtenvorlagen hochladen"
        },
        metadata: {
            search: {
                placeholder: "Suche..."
            },
            emptyList: "Keine Metadaten gefunden",
            emptyListTab: "Keine Metadaten in \"{{tab}}\" gefunden",
            label: {
                type: "Typ",
                categories: "Kategorien",
                custom_fields: "Benutzerdefinierte Felder",
                created_at: "Erstellt am",
            },
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen",
            },
            new: "Neue Metadaten anlegen",
            upload: "Metadaten hochladen",
            tab: {
                all: "Alle Metadaten",
                deleted: "Gelöscht"
            },
            title: "Metadaten",
            table: {
                select: "Auswählen",
                type: "Typ",
                categories: "Kategorien",
                custom_fields: "Benutzerdefinierte Felder",
                created_at: "Erstellt",
                updated_at: "Aktualisiert",
                delete: ""
            }
        },        
        notes: {
            search: {
                placeholder: "Suche..."
            },
            comment: "Kommentar zur Notiz",
            content: "Notiz",
            emptyList: "Keine Notizen gefunden",
            emptyListTab: "Keine Notizen in \"{{tab}}\" gefunden",
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                user_id: "Autor für alle {{selected}} ändern",
                delete: "Alle {{selected}} löschen",
            },
            new: "Neue Notiz anlegen",
            upload: "Notizen hochladen",
            noTitle: "n/a",
            label: "Notizen",
            tab: {
                all: "Alle Notizen",
                deleted: "Gelöscht"
            },
            title: "Titel",
            table: {
                select: "Auswählen",
                title: "Schlagwort",
                email_id: "Email",
                contact_id: "Kontakt",
                user_id: "Autor",
                created_at: "Erstellt",
                delete: ""
            }
        },
        note: {
            title: "Titel",
            relatedContact: "Kontakt",
            content: "Inhalt",
            type: "Typ",
            created_at: "Erstellt am",
            updated_at: "Letztes Update",
            comment: "Kommentar"
        },
        notifications: {
            emailSent: "Email gesendet",
            noNewNotifications: "Keine neuen Nachrichten",
            newEmailsReceived: "neue eMails empfangen",
            newEmailsAnalyzed: "Neue eMail analysiert",
            iconLabel: "Benachrichtigungen"
        },
        orders: {
            search: {
                placeholder: "Suchen..."
            },
            tab: {
                all: "Alle Order",
                deleted: "Gelöschte Order"
            },
            emptyList: "Keine Bestellung gefunden",
            emptyListTab: "Keine Bestellungen in \"{{tab}}\" gefunden",
            label: {
                list: "Order",
                order_number: "Rechnung Nr.",
                customer_first_name: "Vorname des Kunden",
                customer_last_name: "Nachname des Kunden",
                total_amount: "Gesamtbetrag",
                net_amount: "Nettobetrag",
                tax_amount: "Steuerbetrag",
                status: "Status",
                created_at: "Erstellt am",
                updated_at: "Letztes Update",
                address: "Adresse",
                invoice: "Rechnung",
                contact_id: "Kunde"
            },
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                status: "Status für alle {{selected}} ändern",
                delete: "Alle {{selected}} löschen",
            },
            options: {
                status: {
                    pending: "Ausstehend",
                    shipped: "Versandt",
                    delivered: "Geliefert",
                    canceled: "Storniert"
                }
            },
            table: {
                select: "Auswählen",
                customer: "Kontakt",
                order_number: "Rechnung Nr.",
                contact_id: "Kunden",
                total_amount: "Gesamtbetrag",
                net_amount: "Nettobetrag",
                tax_amount: "Steuerbetrag",
                status: "Status",
                created_at: "Erstellt am",
                updated_at: "Letztes Update",
                address: "Adresse",
                delete: ""
            }, 
            new: "Order anlegen",
            upload: "Order hochladen",
        },
        phoneNumber: {
            title: "Telefonnummern", 
            add: "Telefonnummer Hinzufügen",
            call: "Anrufen",
            label: {
                phoneNumber: "Telefonnummer",
                phoneType: "Bezeichnung",
                isPrimary: "Primäre Telefonnummer"
            }
        },
        products: {
            emptyList: "Keine Produkte gefunden",
            emptyListTab: "Keine Produkte in \"{{tab}}\" gefunden",
            label: {
                description: "Beschreibung",
                name: "Name",
                sku: "SKU",
                category: "Kategorie",
                list_price: "Listenpreis",
                created_at: "Erstellungsdatum",
                updated_at: "Letztes Update",
                is_active: "Aktiv",
                image_url: "Image Url"
            },
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen",
            },
            new: "Neues Produkt",
            search: {
                button: "Produkt suchen",
                placeholder: "Suchen..."
            },
            tab: {
                all: "Alle Produkte",
                deleted: "Gelöschte Produkte"
            },
            table: {
                select: "Auswählen",
                description: "Beschreibung",
                name: "Name",
                sku: "SKU",
                category: "Kategorie",
                list_price: "Listenpreis",
                delete: ""
            },
            upload: "Produkte hochladen"
        },   
        prompts: {
            search: {
                placeholder: "Suche..."
            },
            emptyList: "Keine Prompts gefunden",
            emptyListTab: "Keine Prompts in \"{{tab}}\" gefunden",
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen",
            },
            new: "Neuen Prompt anlegen",
            upload: "Prompts hochladen",
            tab: {
                all: "Alle Prompts",
                deleted: "Gelöscht"
            },
            title: "Prompts",
            table: {
                select: "Auswählen",
                key: "Schlüssel",
                locale: "Sprache",
                context: "Kontext",
                role: "Rolle",
                temperature: "Temperatur",
                analytics_temperature: "Analyse-Temperatur",
                isactive: "Aktiv",
                is_deleted: "Gelöscht",
                delete: ""
            },
            label: {
                goal: 'Ziel',
                botname: 'Bot-Name',
                role: 'Rolle',
                task: 'Aufgabe',
                tone: 'Tonfall',
                maxlength: 'Maximale Länge'
            },
            options: {
                Duzen: 'Duzen (informell)',
                Siezen: 'Siezen (formell)'
            },
            titel: {
                conversationStage: 'Gesprächsphasen-Konfiguration'
            }
        }, 
        diagrams: {
            data: {
                received: "Empfangene Emails",
                suggested: "Vorgeschlage Emails",
                sent: "Gesendete Emails"
            },
            label: {
                received: "Empfangen",
                suggested: "Vorgeschlagen",
                sent: "Gesendet"
            },
            period: {
                daily: "Tag",
                monthly: "Monat"
            },
            title: {
                emails: "eMails",
            }
        },
        objectSelector: {
            remove: "Link entfernen",
            removeConfirm: "Sind Sie sicher, dass sie den Link entfernen möchten?",
            searchAndSelect: "Objekt suchen und auswählen...",
            noResults: "Keine Objekte gefunden"
        },
        relatedLists: {
            metric: {
                open: "Offen",
                inProgress: "In Bearbeitung",
                done: "Erledigt",
                all: "Alle",
                pending: "Ausstehend",
                canceled: "Storniert",
                received: "Empfangen",
                sent: "Gesendet",
                scheduled: "Geplant",
                suggested: "Vorgeschlagen"
            }
        },
        reports: {
            label: {
                number: "Anzahl",
                usd: "USD"
            },
            title: {
                CompaniesTotal: "Verfügbare Firmen",
                CommunicationPotential: "Kommunikationspotential",
                runningCommunication: "Laufende Kommunikation",
                companyDetails: "Firmendetails",
                ElevenLabsTokenUsage: "Elevenlabs Token Nutzung",
                ElevenLabsVoiceUsage: "Elevenlabs Custom Voice Nutzung"
            },
            kpis: {
                deleted_companies: "Gelöscht",
                total_companies: "Alle Firmen",
                active_companies: "Aktive Firmen",
                total_emails: "Verfügbare Email Addressen",
                unique_emails: "Eindeutige Email Addressen",
                duplicate_emails: "Dubletten",
                companies_with_email: "Email gesendet",
                companies_without_email: "Keine email gesendet",
                invited: "Eingeladen",
                emptySeats: "Verfügbar",
                pass: "Akzeptiert",
                filtered: "Ausgeschlossen",
                elevenlabs_token_available: "Verfügbare Elevenlabs Token",
                elevenlabs_token_used: "Genutzte Elevenlabs Token",
                elevenlabs_voices_used: "Custom Voices genutzt",
                elevenlabs_voices_available: "Custom Voices verfügbar"
            }
        },
        roles: {
            title: "Rechte / Rollen",
            label: {
                name: "Name",
                description: "Beschreibung",
            },
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen",
            },
            permissions: {
                title: "Berechtigungen",
                resource_type: "Objekt",
                access_filter: "Zugriffsregel",
                access_read: "Lesen",
                access_write: "Schreiben",
                select: "Auswählen",
                addPermission: "Berechtigung hinzufügen",
                addAll: "Alle hinzufügen",
                refresh: "Update"
            },
            tab: {
                all: "Alle Rollen",
                deleted: "Gelöschte Rollen"
            },
            search: {
                placeholder: "Suche..."
            },
            table: {
                select: "Auswählen",
                name: "Name",
                description: "Beschreibung",
                delete: ""
            },
            emptyList: "Keine Rollen gefunden",
            emptyListTab: "Keine Rollen in \"{{tab}}\" gefunden",
            new: "Neue Rolle anlegen",
            upload: "Rollen hochladen"
        },
        select: {
            folder: "Wählen Sie einen Ordner in dem ihre gesendeten eMails gespeichert werden sollen..."
        },
        sentiment: {
            angry: 'Verärgert',
            veryAngry: 'Sehr verärgert'
        },
        setting: {
            avatar: {
                images: "Bilder für KI Berater",
                upload: "Avatarbild Hochladen",
                name: "Name",
                title: "Titel",
                is_enabled: "Aktiviert",
                description: "Beschreibung",
                image_url: "Bild",
                video_url: "Video"
            },
            error: {
                "[Errno 61] Connection refused": "Fehlerhafte Zugangsdaten",
                "authentication failed": "Fehlerhafte eMail Zugangsdaten",
                "Decryption failed for provided credentials": "Bitte geben Sie Ihr Passwort ein",
                "Did not find email credentials": "Fehlende Zugangsdaten",
                noEmail: "Bitte eine Email Adresse Angeben"
            },
            label: {
                authMethod: "Authentifizierungs Methode",
                assistant_language: "Assistentensprache",
                assistant_name: "Assistentenname",
                assistant_talking: "Assistent spricht",
                avatarEnabled: "DID Avatar Anzeigen",
                avatarHeight: "Avatar Höhe",
                avatarImage: "Avatar Bild",
                avatarName: "Avatar Name",
                avatarWidth: "Avatar Breite",
                check_spam: "Aktiviere Spam Check",
                companyLogo: "Firmenlogo",
                conversationHeadline: "Überschrift der Konversation",
                conversationOpeningText: "Eröffnungstext der Konversation",
                conversationSubline: "Unterzeile der Konversation",
                description: "Beschreibung",
                dIdFullBody: "DID Vollkörper",
                dIdKey: "DID Schlüssel",
                elevenLabsKey: "Eleven Labs Schlüssel",
                dIdVoiceID: "DID Sprach-ID",
                email_download_start_date: "Ab diesem Datum werden eMails vom Server geladen",
                email: "Email",
                from_name: "Name der als Absender für eMails verwendet wird",
                username: "Nutzer-Name",
                imap: "IMAP",
                is_active: "aktiv",
                is_default: "default",
                is_single_selection: "Es kann nur eine Kategorie zugewiesen werden",
                name: "Kategorie Name",
                notesEnabled: "Notizen aktiviert",
                object_type: "Objekt für das die Kategorisierung erstellt wird",
                password: "Password",
                requires_analysis: "Emails dieser Kategorie sollen analysiert werden",
                requires_response: "Emails dieser Kategorie sollen beantwortet werden",
                saveConversationQuestion: "Frage zur Speicherung der Konversation",
                seed: "Seed",
                smtp: "SMTP",
                text_analysis_length: "Anzahl Buchstaben die für die Kategorisierung berücksichtigt werden sollen",
                logo: "Logo für den e-Mail Account"
            },
            oauth: {
                success: "Erfolgreich authentifiziert"
            },
            task: {
                name: "Aufgabenname",
                enabled: "Aktiviert",
                created_at: "Erstellt am",
                last_run_at: "Letzter Lauf",
                priority: "Priorität",
                interval: "Intervall"
              },
        },
        settings: {
            avatars: {
                title: "Wähle Deinen KI Berater"
            },
            aitree: "Generelle Einstellungen",
            backgroundTasks: {
                title: "Automatisierungen"
            },
            button: {
                selectTenant: "Log in"
            },
            classification_entries: {
                title: "Kategorie"
            },
            classification_groups: {
                title: "Kategorisierung"
            },
            dashboardCards: {
                users: {
                    title: "Benutzer",
                    text: "Pflegen Sie Ihre Benutzer"
                },
                rightsRoles: {
                    title: "Berechtigungen",
                    text: "Definieren Sie Ihre Zugriffsberechtigungen"
                }
            },
            emailFolder: {
                folder_name: "Ordnername",
                is_sent_folder: "Ordner für Gesendete eMails",
                sync: "Emails aus diesem Ordner herunterladen",
                is_deleted_folder: "Ordner für gelöschte eMails",
                is_primary_folder: "Automatisch Syncronisieren",
                title: "E-Mail-Ordner Einstellungen",
                syncButton: "Update"
            },
            header: {
                createTenant: "Neuen Tenant erstellen",
                selectTenant: "Tenant auswählen"
            },
            label: {
                createTenant: "Tenant Erstellen",
                name: "Name",
                logo_upload_id: "Logo"
            },
            language: {
                title: "Wähle Deine Sprache!"
            },
            signature: {
                title: "eMail Signaturen verwalten"
            },
            prompts: {
                title: "Prompts Konfigurieren"
            },
            phrases: {
                title: "Phrasen aus Chat Antworten löschen"
            },
            section: {
                apis: "Integrationen"
            },
            standardmessage: {
                name: "Bezeichnung der Standard-Antwort",
                subject: "Betreff-Zeile",
                title: "Standard Antworten"
            },
            tenantUsers: {
                title: "Nuter für diesen Client",
                invitations: "Nutzer Einladungen",
                addInvitations: "Nutzer einladen",
                email: "Email Addresse",
                status: "Status",
                expiry: "Gültig bis",
                invited_by: "Eingeladen von",
                copyLink: "Einladungslink kopieren",
                statusPending: "Gültig",
                statusAccepted: "Verwendet",
                statusExpired: "Abgelaufen",
            },
            title: "Einstellungen",
            user: {
                user_id: "User Id",
                first_name: "Vorname",
                last_name: "Nachname"
            },
            userSettings: {
                title: "Nutzer Einstellungen"
            },
            team: {
                title: "Teammitglieder verwalten"
            }
        },
        signature: {
            selectDefault: "Signatur für {{email}} als default auswählen"
        },
        signatures: {
            emptyList: "Keine Signaturen gefunden",
            emptyListTab: "Keine Signaturen in \"{{tab}}\" gefunden",
            label: {
                name: "Name",
                content: "Inhalt",
                is_deleted: "Gelöscht",
                created_at: "Erstellungsdatum",
                updated_at: "Letztes Update"
            },
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen"
            },
            new: "Neue Signatur",
            search: {
                button: "Signatur suchen",
                placeholder: "Suchen..."
            },
            tab: {
                all: "Alle Signaturen",
                deleted: "Gelöschte Signaturen"
            },
            table: {
                select: "Auswählen",
                name: "Name",
                content: "Inhalt",
                delete: ""
            },
            upload: "Signaturen hochladen"
        },  
        social_media_accounts: {
            search: {
                placeholder: "Suche..."
            },
            emptyList: "Keine Social Media Accounts gefunden",
            emptyListTab: "Keine Social Media Accounts in \"{{tab}}\" gefunden",
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                user_id: "Autor für alle {{selected}} ändern",
                delete: "Alle {{selected}} löschen",
            },
            new: "Neuen Social Media Account anlegen",
            upload: "Social Media Accounts hochladen",
            label: {
                list: "Social Media Accounts",
                platform: "Plattform",
                account_url: "Link",
                contact_id: "Kontakt",
            },
            option: {
                platform: {
                    linkedin: "linkedIn",
                    whatsapp: "Whatsapp",
                    instagram: "Insta"
                }
            },
            tab: {
                all: "Alle Social Media Accounts",
                deleted: "Gelöschte Social Media Accounts"
            },
            title: "Titel",
            table: {
                select: "Auswählen",
                platform: "Plattform",
                account_url: "Link",
                contact_id: "Kontakt",
                delete: ""
            },   
        },
        spam_threshold: "Sensibilität beim erkennen von Spam",
        standardmessages: {
            addStandardmessages: "Standardnachrichten erstellen",
            label: "Standard-Nachrichten",
            noLinesAvailable: "Keine Standardnachrichten konfiguriert"
        },
        stages: {
            label: {
                set_for_test: "In Test einbeziehen",
                target_type: "Zieltyp",
                target_percentage: "Gesprächsphasenziel-Erreichung in Prozent",
                target: "Gesprächsphasenziel",
                target_prompt: "Beschreibung Gesprächsphasenziel",
                target_fields: "Abzufragende Information"
            },
            options: {
                select: "Gesprächsende",
                QualitativeAnswer: "Qualitative Frage",
                Number: "Numerisch",
                AskMultipleQuestions: "Informations-Abfrage",
                Decision: "Entscheidung (ja / nein)",
            },
            titel: {
                analytics: "Gesprächsphasen-Übergang"
            }
        },
        team: {
            label: {
                firstName: "Vorname",
                lastName: "Nachname",
                email: "E-Mail-Adresse",
                phone: "Telefonnummer",
                role: "Rolle",
                department: "Abteilung",
                createdAt: "Erstellt am",
                active: "Aktiv"
            }
        },
        tenants: {
            emptyList: "Keine Tenants gefunden",
            emptyListTab: "Keine Tenants in \"{{tab}}\" gefunden",
            label: {
                name: "Name",
                created_at: "Erstellungsdatum",
                is_setup_done: "Setup",
                logo_upload_id: "Logo",
                is_deleted: "Gelöscht",
                login: "Login"
            },
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen"
            },
            new: "Neuer Tenant",
            search: {
                button: "Tenant suchen",
                placeholder: "Suchen..."
            },
            tab: {
                all: "Alle Tenants",
                deleted: "Gelöschte Tenants"
            },
            table: {
                select: "Auswählen",
                name: "Name",
                created_at: "Erstellungsdatum",
                is_setup_done: "Setup",
                logo_upload_id: "Logo",
                login: "Login",
                delete: ""
            },
            upload: "Tenant hochladen",  
            view: {
                list: "Listenansicht",
                tile: "Kachelansicht"
            }
        },
        test: {
            graphError: {
                EdgeWithoutValidNodes: "Gesprächsfluss Fehler: Es gibt Kanten ohne gültige Knoten.",
                MissingTarget: "Gesprächsfluss Fehler: Einem oder mehreren Knoten fehlt ein 'Ziel'.",
                MissingTargetField: "Gesprächsfluss Fehler: Einer oder mehreren Kanten fehlt ein Zielfeld.",
                MultipleStartNodes: "Gesprächsfluss Fehler: Es darf nur einen Startknoten geben.",
                MultipleTestActivated: "Gesprächsfluss Fehler: Mehr als ein Knoten hat 'Test aktiviert'."
            }
        },
        todo: {
            action: {
                refresh: "Aktualisieren"
            },
            created_at: "Erstellungsdatum",
            description: "Beschreibung",
            due_date: "Fälligkeitsdatum",
            emptyList: "Keine Aufgaben gefunden",
            emptyListTab: "Keine Aufgaben in \"{{tab}}\" gefunden",
            headline: "Überschrift",
            is_done: "Erledigt",
            is_verified: "Bestätigt",
            new: "Neues Todo Erstellen",
            priority: "Priorität",
            chat_id: "Projekt-ID",
            responsible: "Owner",
            creator: "Ersteller",
            source_type: "Ursprung",
            start: "Start",
            stop: "Stop",
            status: "Status",
            done: "Als erledigt markieren",
            target: "Ziel",
            type: "Typ",
            contact: "Relevanter Kontakt",
            sourceEmail: "Email auf der die Aufgabe basiert",
            inProgressByAI: "Dieses Todo ist aktuell in Arbeit durch Ihren KI Agenten..."
        },
        todos: {
            emptyList: "Keine Aufgaben gefunden",
            emptyListTab: "Keine Aufgaben in \"{{tab}}\" gefunden",
            label: "Aufgaben",
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                responsible_user_id: "Owner für alle {{selected}} ändern",
                delete: "Alle {{selected}} löschen",
            },
            new: "Neue Aufgabe erstellen",
            options: {
                status: {
                    open: "Offen",
                    inProgress: "In Arbeit",
                    done: "Erledigt",
                },
                prio: {
                    hight: "Hoch",
                    middle: "Mittel",
                    low: "Gering"
                }
            },
            search: {
                placeholder: "Suchen..."
            },
            table: {
                select: "Auswählen",
                contact_id: "Kunde",
                status: "Status",
                due_date: "Fällig",
                headline: "Aufgabe",
                responsible_user_id: "Team",
                delete: ""
            },
            tab: {
                all: "Alle Todos",
                inProgress: "In Arbeit",
                "In Progress": "In Arbeit",
                done: "Erledigt",
                deleted: "Gelöscht"
            },
            upload: "Todos hochladen"
        },
        token: {
            usage: "KI Nutzung"
        },
        toolbar: {
            back: "Zurück",
            delete: "Löschen",
            undelete: "Wiederherstellen",
            showAIAgent: "AI Agenten anzeigen",
            hideAIAgent: "AI Agenten ausblenden"
        },
        term_corrections: {
            search: {
                placeholder: "Suche..."
            },
            emptyList: "Keine Korrekturen gefunden",
            emptyListTab: "Keine Korrekturen in \"{{tab}}\" gefunden",
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen",
            },
            label: {
                original: "Original",
                corrected: "Korrektur",
                language: "Sprache",
            },
            new: "Neue Korrektur anlegen",
            upload: "Korrekturen hochladen",
            tab: {
                all: "Alle Korrekturen",
                deleted: "Gelöscht"
            },
            title: "Korrekturen",
            table: {
                select: "Auswählen",
                original: "Original",
                corrected: "Korrektur",
                language: "Sprache",
                created_at: "Erstellt",
                is_deleted: "Gelöscht",
                delete: ""
            }
        },        
        upload: {
            sse:{
                start: "Beginne Bildanalyse",
                step: "Analyse fertig von Seite {{count}} / {{total}}"
            },
        }, 
        uploads: {
            upload: "Dokument hochladen",
            ai: {
                analyze: "Dokument Analysieren",
                prepare: "Generiere Import Vorschau",
                import: "Daten importieren"
            },
            emptyList: "Keine Uploads gefunden",
            emptyListTab: "Keine Uploads in \"{{tab}}\" gefunden",
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen",
            },
            new: "Neues Dokument Hochladen",
            search: {
                placeholder: "Suche"
            },
            tab: {
                all: "Alle Uploads",
                deleted: "Gelöschte Uploads",
            },
            todo: "Aufgaben hochladen",
            table: {
                select: "Auswählen",
                filename: "Name",
                status: "Status",
                created_at: "Erstellt am",
                content_type: "Format",
                type: "Typ",
                delete: ""
            }, 
            toolbar: {
                delete: "Löschen",
                undelete: "Wiederherstellen"
            },
            label: {
                filename: "Dateiname",
                file_path: "Dateipfad",
                content_type: "Inhaltstyp",
                is_public: "Im Web teilen",
                status: "Status",
                type: "Typ",
                created_at: "Erstellt am",
                defaultAlt: "Vom Nutzer hochgeladene Medien",
                dragDrop: "Dateien hierher ziehen oder klicken, um Dateien auszuwählen",
                search: "Vorherigen Upload suchen"
            },
            options: {
                status: {
                    pending: 'Ausstehend',
                    uploaded: 'Hochgeladen',
                    parsed: 'Entschlüsselt',
                    inMapping: 'Zuordnung läuft',
                    mapped: 'Zugeordnet',
                    inAnalyzing: 'Analyse läuft',
                    analzed: 'Analysiert'
                },
                contentType: {
                    pdf: 'PDF-Dokument',
                    jpeg: 'JPEG-Bild',
                    pkcs7: 'Signierte Datei (PKCS#7)',
                    png: 'PNG-Bild',
                    gif: 'GIF-Bild',
                    plain: 'Textdatei',
                    tnef: 'TNEF-Anhang (MS-TNEF)'
                }
            }
        },
        used: {
            ai: {
                token: "Genutzte KI Token"
            }
        },
        userProfile: {
            title: "Nutzer Profil (\"{{role}}\")",
            noRole: "Keine Rolle zugewiesen"
        },
        users: {
            roles: {
                AddUserRole: "Rolle hinzufügen",
                title: "Rollen"
            },
            title: "Nutzerdaten",
            invitation: {
                email: "EMail",
                title: "Einladung",
                status: "Status",
                expiry: "Gültig bis",
            },
            label: {
                first_name: "Vorname",
                last_name: "Nachname",
                middle_names: "Mittel-Namen",
                email: "Email",
                phone: "Telefon",
                language: "Bevorzugte Sprache",
                birthday: "Geburts"
            },
            object: {
                invistationStatus: {
                    pending: "Ausstehend",
                    accepted: "Akzeptiert",
                    expired: "Abgelaufen",
                    duplicate_user: "User existierte bereits"
                }
            },
            multiSelect: {
                selectAll: "Alle {{total}} auswählen",
                deselectAll: "Alle {{total}} abwählen",
                delete: "Alle {{selected}} löschen",
            },
            tab: {
                all: "Alle User",
                deleted: "Gelöschte User"
            },
            search: {
                placeholder: "Suche..."
            },
            table: {
                select: "Auswählen",
                first_name: "Vorname",
                last_name: "Nachname",
                email: "Email",
                phone: "Telefon",
                status: "status",
                role_id: "Rolle",
                delete: ""
            },
            emptyList: "Keine User gefunden",
            emptyListTab: "Keine User in \"{{tab}}\" gefunden",
            new: "Neuen User anlegen",
            upload: "User hochladen"
        },
        userSetting: {
            analyze_all_contacts: "Emails aller Absender analysieren",
            auto_send_after_talking: "Auto-Senden nach Sprechen",
            default_account_settings: "Standard-Email in der Listenansicht",
            is_ai_control_visible: "AI Control Menu anzeigen",
            is_assistant_talking: "Assistent spricht automatisch",
            is_avatars_visible: "Avatar Menu anzeigen",
            is_chat_designs_visible: "Chat Designs Menu anzeigen",
            is_chat_sessions_visible: "Chat Sessions Menu anzeigen",
            is_chats_visible: "Chats Menu anzeigen",
            is_companies_visible: "Unternehmen Menu anzeigen",
            is_communication_plans_visible: "Kommunikationspläne Menu anzeigen",
            is_contracts_visible: "Verträge Menu anzeigen",
            is_customers_visible: "Kunden Menu anzeigen",
            is_documents_visible: "Dokumente Menu anzeigen",
            is_account_settings_visible: "Email Settings Menu anzeigen",
            is_emails_visible: "Emails Menu anzeigen",
            is_events_visible: "Ereignisse Menu anzeigen",
            is_event_participants_visible: "Event-Teilnehmer Menu anzeigen",   
            is_import_data_visible: "Importierte Daten Menu anzeigen",          
            is_integrations_visible: "Integrationen Menu anzeigen",
            is_interactions_visible: "Interaktionen Menu anzeigen",
            is_knowledge_visible: "Bibliotheks Menu anzeigen",
            is_message_templates_visible: "Nachrichtenvorlagen Menu anzeigen",
            is_metadata_visible: "Metadaten Menu anzeigen",                     
            is_notes_visible: "Notizen Menu anzeigen",
            is_orders_visible: "Bestellungen Menu anzeigen",
            is_products_visible: "Produkte Menu anzeigen",
            is_profile_visible: "Profil Menu anzeigen",
            is_prompts_visible: "Prompts Menu anzeigen",                        
            is_roles_visible: "Rechte / Rollen Menu anzeigen",
            is_settings_visible: "Einstellungen Menu anzeigen",
            is_signatures_visible: "Signaturen Menu anzeigen",
            is_term_corrections_visible: "Korrekturen Menu anzeigen",            
            is_todos_visible: "Aufgaben Menu anzeigen",
            is_uploads_visible: "Uploads Menu anzeigen",
            is_users_visible: "Benutzer Menu anzeigen",
            list_page_length: "Suchergebnisse pro Seite",
            show_icons: "Beschreibungen als Icons anzeigen"
        },
        
        AI_Evaluation: "KI Bewertung",
        ai_settings: "KI Einstellungen",
        analytics_temperature: "Temperatur",
        analytics_text: "Prompt für das analytische Sprachmodell",
        app_name: "Mainition CRM Automation",
        chat_avatar: "Avatar",
        chat_branding: "Website-Branding",
        Chat_Materials: "Multimedia Materialien Verwalten",
        chat_settings: "Chat Einstellungen",
        chat_Texts: "Statische Texte",
        chat_voice: "Sprach-Ausgabe",
        Chats: "Chats",
        Completed_Tasks: "Erledigte Aufgaben",
        condition_field: "Entscheidungsfeld",
        condition_value: "Pfad-Attribut",
        Configure_AI: "Konfiguriere den KI-Assistenten",
        conversationstage: {
            actions: "Übergangseffekte",
            analyticalLLM: "Analytisches LLM",
            analytics: "Gesprächsphasen-Übergang",
            api: "API / Integration",
            conditions: "Übergangsbedingungen",
            configuration: "Gesprächsführung: ",
            connection: {
                title: "Konfiguriere Gesprächsübergänge",
                createCustomer: "Kontakt erstellen",
                createDossier: "Kundendossier erstellen",
                conditionField: "Übergangsbedingung",
                conditionValue: "Übergangswert"
            },
            conversation: "Gesprächsphasen-Konfiguration",
            conversationalLLM: "Konversations LLM",
            data: "Anzeige",
            input: "Input / Hintergrund",
            test: "Test Konfiguration",
        },
        Current_Chats: "Laufende Konversationen",
        Daily_Sales: "Tagesumsatz",
        deals: "Abschlüsse",
        dont_show: "Nicht Anzeigen",
        email_alert_fetchEmails: "Lade neue Emails herunter...",
        email_assistant: "Email Assistent",
        email_list_header: "Meine Emails",
        Goal: "Ziel das der Bot erreichen soll",
        Input: "Input / Hintergrund",
        is_active: "Aktiv",
        key_management: "Software-Schlüssel",
        keywords: "Schlagwörter",
        knowledge_settings: "Informationsquellen",
        label: {
            firstname: "Vorname",
            lastname: "Nachname",
            email: "Email",
            phone: "Telefonnummer"
        },
        Last_Activity: "Letzte Aktivität",
        Lead_Score: "Lead Score",
        Leads: "Leads",
        length: "Maximale Antwort-Länge",
        llm: "KI",
        locale: "Sprache",
        model: "Engine",
        Name: "Name",
        new_leads: "Neue Leads",
        prompt: "Analyse Anweisungen",
        field_name: "Technischer Name",
        field_display_name: "Name",
        Role: "Rolle des Bots (z.B. Produktexperte)",
        Sales_Stage: "Gesprächsphase",
        Save: "Speichern",
        show: "Anzeigen",
        source_section: "CSS Klasse",
        source: "URL",
        Stage_Completion: "Phasen Fortschritt",
        stage_key: "Phasen ID",
        target_fields: "Abzufragende Informationen",
        target_percentage: "Gesprächsphasenziel-Erreichung in Prozent",
        target_prompt: "Beschreibung Gesprächsphasenziel",
        target_type: "Art Gesprächsziel",
        target: "Gesprächsphasenziel",
        Task: "Aufgabe (Was soll der Bot tun, z.B. Frage nach dem Namen)",
        temperature: "LLM Spielraum",
        tenant: "Projekt",
        test_history: "Test-Konversation",
        text: "Text",
        title_configure_conversation_flow: "Gesprächsfluss konfigurieren",
        Tone: "Ton",
        topic: "Thema",
        Total_Engagements: "Engagements Insgesamt",
        Wizard:{
            ChooseAvatar: "Wähle Deinen KI Berater",
            Briefing: "Briefe Deinen KI Berater",
            Channels: "Kommunikationskanäle"
        },
        savvySpeak: {
            title: "Willkommen bei SavvySpeak",
            welcomeMessage: "Hallo! Ich bin dein Lehrer und helfe Dir, schnell Fortschritte zu machen!",
            dashboardCards: {
                exercise: {
                    title: "Sprache Üben",
                    text: "Übe englisch sprechen mit Deinem Avatar"
                },
                progress: {
                    title: "Lernfortschritt",
                    text: "Sehe deinen aktuellen Lernfortschritt"
                },
                profile: {
                    title: "Deine Daten",
                    text: "Pflege Deine Daten"
                },
                userManagment: {
                    title: "Nutzerverwaltung",
                    text: "Schüler und Lehrer einladen"
                }
            }
        },
        speicherfuchs: {
            title: "Willkommen bei Speicherfuchs",
            welcomeMessage: "Hallo! Ich bin Lina und helfe Dir, Dich im Bürokratie-Jungle zurecht zu finden.",
            dashboardCards: {
                yourData: {
                    title: "Deine Daten",
                    text: "Überblick über Deine Daten"
                },
                yourCustomers: {
                    title: "Deine Kunden",
                    text: "Überblick über Deine Kunden"
                },
                uploadDocuments: {
                    title: "Unterlagen hochladen",
                    text: "Lade deine Bescheid und Dokumente hoch"
                },
                submitApplication: {
                    title: "Antrag stellen",
                    text: "Kindergeld, SGB II, Aufenthalt"
                },
                appointments: {
                    title: "Termine & Fristen im Blick behalten",
                    text: ""
                },
                userManagment: {
                    title: "Nutzerverwaltung",
                    text: "Helfer und Kunden Einladen / Deaktivieren"
                }
            }
        }          
    }
}